"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.experienceTable = exports.levelUpOptions = void 0;
var app_1 = require("../../app");
var units_1 = require("../../data/units");
/**
 * Potential Perks
 * * skeletons gain a 15/30/45/60/75/100 % chance to drop bones on death
 * * skeletons gain a 35/70/100 % chance to drop held items on death
 * * skeletons gain HP regeneration
 * * player can sacrifice HP to heal skeletons
 */
var levelUpOptions = function (gameState) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return [
        // Player
        {
            name: "Move Speed",
            description: "Increases your max speed by 0.3.",
            currentStats: "Max Speed: ".concat(gameState.player.getStats().maxSpeed),
            onSelect: function () {
                gameState.player.addToStat("moveSpeed", 0.15);
                gameState.player.addToStat("maxSpeed", 0.35);
                app_1.appService.resume();
            }
        },
        {
            name: "Summoning Spell",
            description: "Increases how quickly your summoning circle grows its radius by 30.",
            currentStats: "Radius: ".concat(gameState.player.getStats().spellRadius),
            onSelect: function () {
                gameState.player.addToStat("castingSpeed", 0.5);
                gameState.player.addToStat("spellRadius", 35);
                app_1.appService.resume();
            }
        },
        {
            name: "Health Regeneration",
            description: "Increases your health regeneration by 0.15 / s.",
            currentStats: "Regeneration: ".concat((gameState.player.getStats().HPregeneration * 5).toFixed(2), " / s"),
            onSelect: function () {
                gameState.player.addToStat("HPregeneration", 0.03);
                app_1.appService.resume();
            }
        },
        {
            name: "Max Health",
            description: "Increases your max health by 10.",
            currentStats: "Max HP: ".concat(gameState.player.getStats().maxHP),
            onSelect: function () {
                gameState.player.addToStat("maxHP", 10);
                gameState.player.health.setMaxHP(gameState.player.getStats().maxHP);
                gameState.player.health.heal(10);
                app_1.appService.resume();
            }
        },
        {
            name: "Armor",
            description: "Increases your armor by 2.",
            currentStats: "Armor: ".concat(gameState.player.getStats().armor),
            onSelect: function () {
                gameState.player.addToStat("armor", 2);
                app_1.appService.resume();
            },
        },
        // MINIONS
        {
            name: "Minion Speed",
            description: "Increases minion movement speed by 0.4.",
            currentStats: "Minion Max Speed: ".concat((_b = (_a = gameState.minions) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.stats.maxSpeed),
            onSelect: function () {
                (0, units_1.addToStat)("skeleton", "moveSpeed", 0.15);
                (0, units_1.addToStat)("skeleton", "maxSpeed", 0.4);
                app_1.appService.resume();
            }
        },
        {
            name: "Minion Max Hit",
            description: "Increases the max hit of your minions by 1.",
            currentStats: "Minion Max Hit: ".concat((_d = (_c = gameState.minions) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.stats.maxHit),
            onSelect: function () {
                (0, units_1.addToStat)("skeleton", "maxHit", 1);
                app_1.appService.resume();
            }
        },
        {
            name: "Minion Armor",
            description: "Increases minion armor by 1.",
            currentStats: "Minion Armor: ".concat((_f = (_e = gameState.minions) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.stats.armor),
            onSelect: function () {
                (0, units_1.addToStat)("skeleton", "armor", 1);
                app_1.appService.resume();
            }
        },
        {
            name: "Minion Accuracy",
            description: "Increases minion accuracy by 1.",
            currentStats: "Minion Accuracy: ".concat((_h = (_g = gameState.minions) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.stats.attackBonus),
            onSelect: function () {
                (0, units_1.addToStat)("skeleton", "attackBonus", 1);
                app_1.appService.resume();
            }
        },
        {
            name: "Minion MaxHP",
            description: "Increases max HP of your minions by 5.",
            currentStats: "Minion MaxHP: ".concat((_k = (_j = gameState.minions) === null || _j === void 0 ? void 0 : _j[0]) === null || _k === void 0 ? void 0 : _k.stats.maxHP),
            onSelect: function () {
                (0, units_1.addToStat)("skeleton", "maxHP", 5);
                gameState.minions.forEach(function (m) {
                    m.health.setMaxHP(m.stats.maxHP);
                    m.health.heal(5);
                });
                app_1.appService.resume();
            }
        },
        {
            name: "Minion Crit Chance",
            description: "Increases your minion's crit chance by 5%.",
            currentStats: "Minion Crit Chance: ".concat((_m = (_l = gameState.minions) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m.stats.critChance, "%"),
            onSelect: function () {
                (0, units_1.addToStat)("skeleton", "critChance", 5);
                app_1.appService.resume();
            }
        },
        {
            name: "Minion Crit Damage",
            description: "Increases multiplier of your minion's critical hits by 0.5x.",
            currentStats: "Minion Crit Damage: ".concat((_p = (_o = gameState.minions) === null || _o === void 0 ? void 0 : _o[0]) === null || _p === void 0 ? void 0 : _p.stats.critDamage, "x"),
            onSelect: function () {
                (0, units_1.addToStat)("skeleton", "critDamage", 0.5);
                app_1.appService.resume();
            }
        },
    ];
};
exports.levelUpOptions = levelUpOptions;
var levelUpOption = function () {
    // decide on random attribute to increase
    // decide on random attribute to decrease OR random enemy attribute to increase?
    // decide on percent to increase
    // decide on percent to decrease
    // sometimes upgrades are bad?
    // update stats for LIVING vs FUTURE minions?
    // sacrifice minions to re-roll?
};
var createExperienceTable = function () {
    var table = { 1: 35 };
    for (var i = 2; i < 50; i++) {
        table[i] = table[i - 1] + 10;
    }
    return table;
};
exports.experienceTable = createExperienceTable();
/*
export const experienceTable = {
  1: 35,
  2: 75,
  3: 120,
  4: 170,
  5: 225,
  6: 285,
  7: 350,
  8: 420,
  9: 495,
  10: 575,
  11: 660,
  12: 750,
  13: 845,
  14: 945,
  15: 1050,
  16: 1160,
  17: 1275,
  18: 1395,
  19: 1520,
  20: 1650,
  21: 1650,
  22: 1650,
  23: 1650,
  24: 1650,
  25: 1650,
  26: 1650,
  27: 1650,
  28: 1650,
  29: 1650,
  30: 1650,
}
*/
